import React from 'react';
import './TitleSection.scss';
import {TrackEvent} from '../services/gtmEvents';

const TitleSection = ({title, vermas, url}) => {
  return (
    <div className="container main-title-container">
      <div className="title-container">
        <h2>{title}</h2>
        <a href={url} onClick={() => TrackEvent('Navigation', 'See more', title)} target="_blank"><p>{vermas}</p></a>
      </div>
    </div>
  );
};

export default TitleSection;
